/* ============================================================
   CHAIN OF THORNS — THEME JS
   ============================================================ */

(function () {
  'use strict';

  /* ── Utilities ────────────────────────────────────────────── */

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  /* ── Landing overlay ──────────────────────────────────────── */

  function initLanding() {
    const landing = $('#landing-overlay');
    if (!landing) return;

    // ?landing in the URL forces the overlay regardless of session state
    const forceShow = new URLSearchParams(window.location.search).has('landing');

    // Skip if already seen this session (unless forced)
    if (!forceShow && sessionStorage.getItem('cot_entered')) {
      landing.classList.add('is-hidden');
      return;
    }

    function dismissLanding() {
      sessionStorage.setItem('cot_entered', '1');
      landing.classList.add('is-hidden');
      landing.addEventListener('transitionend', () => {
        landing.remove();
      }, { once: true });
    }

    // TEMP: site not yet open — dismiss interaction disabled
    // landing.addEventListener('click', dismissLanding);
    // landing.addEventListener('keydown', (e) => {
    //   if (e.key === 'Enter' || e.key === ' ') dismissLanding();
    // });
  }

  /* ── Landing distort effect (block-grid glitch) ─────────── */
  //
  // Screen divided into BLOCK×BLOCK px chunks. Each chunk stores a UV
  // displacement that decays to zero when the mouse stops. Moving the
  // mouse "tugs" nearby blocks in the velocity direction; per-block random
  // variation + occasional random sparks give the glitchy irregular look.
  // NEAREST-filter on the displacement texture gives hard square edges.
  //
  function initDistortEffect() {
    const landing  = document.getElementById('landing-overlay');
    if (!landing) return;
    const video    = landing.querySelector('.landing__video');
    const modelCvs = document.getElementById('landing-canvas');
    if (!modelCvs) return;

    const cvs = document.createElement('canvas');
    Object.assign(cvs.style, {
      position: 'absolute', inset: '0',
      width: '100%', height: '100%',
      zIndex: '3', pointerEvents: 'none',
    });
    landing.insertBefore(cvs, landing.querySelector('.landing__bottom'));

    const gl = cvs.getContext('webgl', { alpha: true, premultipliedAlpha: false });
    if (!gl) { cvs.remove(); return; }
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    gl.clearColor(0, 0, 0, 0);

    // ── Tuning ────────────────────────────────────────────────
    const BLOCK     = 40;   // px — visible glitch square size
    const DECAY     = 0.9; // per-frame decay (lower = faster dissipation)
    const RADIUS_PX = 150;  // mouse influence radius in px
    const MAX_UV    = 0.01; // max UV displacement per block
  

    // ── Shaders ───────────────────────────────────────────────
    const VS = `
      attribute vec2 a_pos;
      varying   vec2 v_uv;
      void main() {
        v_uv        = a_pos * 0.5 + 0.5;
        gl_Position = vec4(a_pos, 0.0, 1.0);
      }
    `;

    // The displacement texture (NEAREST filter) is sampled at the block's
    // quantised UV, giving every pixel in a block the *same* offset →
    // hard-edged glitch squares.  Canvas is transparent where offset ≈ 0
    // so the original video/model shows through unaffected.
    const FS = `
      precision mediump float;
      uniform sampler2D u_video;
      uniform sampler2D u_model;
      uniform sampler2D u_disp;    // block displacement texture (NEAREST)
      uniform vec2  u_gridSize;    // vec2(gridW, gridH)
      uniform float u_maxUV;
      uniform vec2  u_mCenter;
      uniform vec2  u_mSize;
      uniform float u_hasVideo;
      varying vec2  v_uv;

      void main() {
        // Snap to block — NEAREST filter keeps square edges hard
        vec2 blockIdx  = floor(v_uv * u_gridSize);
        vec2 dispTexUV = (blockIdx + 0.5) / u_gridSize;
        vec4 d = texture2D(u_disp, dispTexUV);

        // Decode [0,1] → [-maxUV, +maxUV]
        float uvDx = (d.r - 0.5) * 2.0 * u_maxUV;
        float uvDy = (d.g - 0.5) * 2.0 * u_maxUV;
        vec2  wuv  = clamp(v_uv + vec2(uvDx, uvDy), 0.0, 1.0);

        // Composite displaced video + model
        vec4 result = vec4(0.0);
        if (u_hasVideo > 0.5) {
          vec4 vCol = texture2D(u_video, wuv);
          result    = vec4(vCol.rgb * 0.18, 1.0);
        }

        vec2 topLeft = u_mCenter - u_mSize * 0.5;
        vec2 muv     = (wuv - topLeft) / u_mSize;
        if (muv.x >= 0.0 && muv.x <= 1.0 &&
            muv.y >= 0.0 && muv.y <= 1.0) {
          vec4 mCol  = texture2D(u_model, muv);
          result.rgb = mix(result.rgb, mCol.rgb, mCol.a);
          if (u_hasVideo < 0.5) result.a = mCol.a;
        }

        // Transparent where displacement is negligible
        float mag  = length(d.rg - 0.5);
        result.a  *= smoothstep(0.008, 0.022, mag);
        gl_FragColor = result;
      }
    `;

    function compile(type, src) {
      const s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
        console.error('[distort]', gl.getShaderInfoLog(s)); return null;
      }
      return s;
    }
    const vs = compile(gl.VERTEX_SHADER,   VS);
    const fs = compile(gl.FRAGMENT_SHADER, FS);
    if (!vs || !fs) { cvs.remove(); return; }

    const prog = gl.createProgram();
    gl.attachShader(prog, vs); gl.attachShader(prog, fs);
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) {
      console.error('[distort]', gl.getProgramInfoLog(prog)); cvs.remove(); return;
    }
    gl.useProgram(prog);

    const buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 1,-1, -1,1, 1,1]), gl.STATIC_DRAW);
    const aPos = gl.getAttribLocation(prog, 'a_pos');
    gl.enableVertexAttribArray(aPos);
    gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);

    const uGridSize = gl.getUniformLocation(prog, 'u_gridSize');
    const uMaxUV    = gl.getUniformLocation(prog, 'u_maxUV');
    const uMCenter  = gl.getUniformLocation(prog, 'u_mCenter');
    const uMSize    = gl.getUniformLocation(prog, 'u_mSize');
    const uHasVideo = gl.getUniformLocation(prog, 'u_hasVideo');
    const uVideo    = gl.getUniformLocation(prog, 'u_video');
    const uModel    = gl.getUniformLocation(prog, 'u_model');
    const uDisp     = gl.getUniformLocation(prog, 'u_disp');

    function makeTex(filter) {
      const t = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, t);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filter);
      return t;
    }
    const videoTex = makeTex(gl.LINEAR);
    const modelTex = makeTex(gl.LINEAR);
    const dispTex  = makeTex(gl.NEAREST); // hard block edges
    let videoOk    = null;

    // ── Block grid ────────────────────────────────────────────
    let gridW = 1, gridH = 1;
    let dispData;    // Float32 [dx_uv, dy_uv] per block (screen row order)
    let blockVary;   // per-block random variation factor [0.4..2.0]
    let dispTexData; // Uint8 RGBA for GPU upload

    function initGrid() {
      gridW = Math.ceil(cW / BLOCK) + 1;
      gridH = Math.ceil(cH / BLOCK) + 1;
      const n = gridW * gridH;
      dispData    = new Float32Array(n * 2);
      blockVary   = new Float32Array(n);
      dispTexData = new Uint8Array(n * 4);
      for (let i = 0; i < n; i++) {
        blockVary[i]       = 0.4 + Math.random() * 1.6;
        dispTexData[i*4+3] = 255;
      }
    }

    // Encode displacement floats to RGBA8 and upload.
    // UNPACK_FLIP_Y_WEBGL=true aligns screen-row-0 (top) with GL UV y≈1 (top),
    // so the shader can look up blocks using v_uv directly without Y-flipping.
    function uploadDispTex() {
      const n = gridW * gridH;
      for (let i = 0; i < n; i++) {
        dispTexData[i*4  ] = Math.max(0, Math.min(255,
          Math.round((dispData[i*2  ] / MAX_UV * 0.5 + 0.5) * 255)));
        dispTexData[i*4+1] = Math.max(0, Math.min(255,
          Math.round((dispData[i*2+1] / MAX_UV * 0.5 + 0.5) * 255)));
      }
      gl.activeTexture(gl.TEXTURE2);
      gl.bindTexture(gl.TEXTURE_2D, dispTex);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gridW, gridH, 0,
                    gl.RGBA, gl.UNSIGNED_BYTE, dispTexData);
    }

    // ── Sizing ────────────────────────────────────────────────
    let cW = 1, cH = 1;
    let mCenterX = 0.5, mCenterY = 0.5, mSizeX = 0.5, mSizeY = 0.5;

    function resize() {
      const rect = landing.getBoundingClientRect();
      cW = Math.round(rect.width)  || window.innerWidth;
      cH = Math.round(rect.height) || window.innerHeight;
      cvs.width  = cW;
      cvs.height = cH;
      gl.viewport(0, 0, cW, cH);
      const mWrap = landing.querySelector('.landing__model-wrap');
      if (mWrap) {
        const mRect = mWrap.getBoundingClientRect();
        mCenterX = (mRect.left - rect.left + mRect.width  * 0.5) / cW;
        mCenterY = 1.0 - (mRect.top - rect.top + mRect.height * 0.5) / cH;
        mSizeX   = mRect.width  / cW;
        mSizeY   = mRect.height / cH;
      }
      initGrid();
    }
    requestAnimationFrame(resize);
    new ResizeObserver(resize).observe(landing);

    // ── Mouse ─────────────────────────────────────────────────
    // No spring — cursor position is used directly for the influence centre.
    // Velocity is derived from per-frame position delta (smoothed EMA).
    let mousePxX = -9999, mousePxY = -9999;
    let prevMX = -9999, prevMY = -9999;
    let vX = 0, vY = 0;

    landing.addEventListener('mousemove', (e) => {
      const r = landing.getBoundingClientRect();
      mousePxX = e.clientX - r.left;
      mousePxY = e.clientY - r.top;
    });
    landing.addEventListener('mouseleave', () => { mousePxX = -9999; });

    // ── Block update (runs every frame) ───────────────────────
    function updateBlocks() {
      const onScreen = mousePxX > -100;

      // Velocity from position delta (EMA smoothing to avoid single-frame spikes)
      if (onScreen && prevMX > -100) {
        vX = vX * 0.5 + (mousePxX - prevMX) * 0.5;
        vY = vY * 0.5 + (mousePxY - prevMY) * 0.5;
      } else {
        vX *= 0.75;
        vY *= 0.75;
      }
      prevMX = mousePxX;
      prevMY = mousePxY;

      const speed = Math.hypot(vX, vY);

      if (onScreen && speed > 1.5) {
        const nx  = vX / speed; // normalised tug direction X
        const ny  = vY / speed; // normalised tug direction Y (screen-down = +)
        const str = Math.min(speed, 28) / 28; // 0..1

        for (let gy = 0; gy < gridH; gy++) {
          for (let gx = 0; gx < gridW; gx++) {
            const bx   = gx * BLOCK + BLOCK * 0.5;
            const by   = gy * BLOCK + BLOCK * 0.5;
            // Distance from actual cursor (not spring point)
            const dist = Math.hypot(bx - mousePxX, by - mousePxY);
            if (dist > RADIUS_PX) continue;

            const falloff = 1 - dist / RADIUS_PX;
            // Cubic falloff: very intense at centre, sharp taper outward
            const t       = falloff * falloff * falloff * str;
            const vary    = blockVary[gy * gridW + gx];
            const idx     = (gy * gridW + gx) * 2;

            // X: right = +UV-x  Y: screen-down = +UV-y (content moves down)
            dispData[idx    ] += nx * t * vary * MAX_UV;
            dispData[idx + 1] += ny * t * vary * MAX_UV;

            const mag = Math.hypot(dispData[idx], dispData[idx + 1]);
            if (mag > MAX_UV) {
              const s = MAX_UV / mag;
              dispData[idx] *= s; dispData[idx + 1] *= s;
            }
          }
        }

        // Occasional random glitch spark: a stray block near mouse
        // gets a large random-direction jolt for a chaotic digital feel
        if (Math.random() < 0.20) {
          const maxB = Math.ceil(RADIUS_PX / BLOCK);
          const sGX  = Math.round(mousePxX / BLOCK + (Math.random() - 0.5) * maxB * 2);
          const sGY  = Math.round(mousePxY / BLOCK + (Math.random() - 0.5) * maxB * 2);
          if (sGX >= 0 && sGX < gridW && sGY >= 0 && sGY < gridH) {
            const si = (sGY * gridW + sGX) * 2;
            dispData[si    ] = (Math.random() - 0.5) * MAX_UV * 2.8;
            dispData[si + 1] = (Math.random() - 0.5) * MAX_UV * 2.8;
          }
        }
      }

      // Decay all blocks toward zero every frame
      for (let i = 0; i < dispData.length; i++) dispData[i] *= DECAY;
    }

    // ── Animation loop ────────────────────────────────────────
    let raf;
    (function tick() {
      raf = requestAnimationFrame(tick);
      if (!cvs.isConnected) { cancelAnimationFrame(raf); return; }

      updateBlocks();
      uploadDispTex();

      gl.clear(gl.COLOR_BUFFER_BIT);

      // Three.js model canvas (preserveDrawingBuffer=true)
      gl.activeTexture(gl.TEXTURE1);
      gl.bindTexture(gl.TEXTURE_2D, modelTex);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      try { gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, modelCvs); } catch(e){}

      // Video (CORS-test once, update every frame thereafter)
      if (videoOk === null && video && video.readyState >= 2) {
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, videoTex);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        try { gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video); videoOk = true; }
        catch(e) { videoOk = false; }
      } else if (videoOk === true && video && !video.paused) {
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, videoTex);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        try { gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video); } catch(e){}
      }

      gl.useProgram(prog);
      gl.uniform2f(uGridSize, gridW, gridH);
      gl.uniform1f(uMaxUV,    MAX_UV);
      gl.uniform2f(uMCenter,  mCenterX, mCenterY);
      gl.uniform2f(uMSize,    mSizeX,   mSizeY);
      gl.uniform1f(uHasVideo, videoOk === true ? 1.0 : 0.0);
      gl.uniform1i(uVideo, 0);
      gl.uniform1i(uModel, 1);
      gl.uniform1i(uDisp,  2);

      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    })();

    const obs = new MutationObserver(() => {
      if (!document.contains(landing)) { cancelAnimationFrame(raf); obs.disconnect(); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  /* ── Product image glitch (block-grid, separate tuning) ──── */
  //
  // Same block-displacement technique as the landing effect but applied to
  // the product-detail background images. Separate tuning constants let you
  // dial the two effects independently.
  //
  function initProductImageDistort() {
    const bgEl = document.querySelector('.product-detail__bg');
    if (!bgEl) return;
    const srcImg = bgEl.querySelector('.product-detail__bg-img');
    if (!srcImg) return;

    // Make sure the container is a positioning root for the overlay canvas
    if (getComputedStyle(bgEl).position === 'static') bgEl.style.position = 'relative';

    const cvs = document.createElement('canvas');
    Object.assign(cvs.style, {
      position: 'absolute', inset: '0',
      width: '100%', height: '100%',
      zIndex: '2', pointerEvents: 'none',
    });
    bgEl.appendChild(cvs);

    const gl = cvs.getContext('webgl', { alpha: true, premultipliedAlpha: false });
    if (!gl) { cvs.remove(); return; }
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    gl.clearColor(0, 0, 0, 0);

    // ── Product-image tuning (edit these independently of landing) ──
    const P_BLOCK     = 22;    // px — glitch square size
    const P_DECAY     = 0.45;  // per-frame decay
    const P_RADIUS_PX = 180;   // mouse influence radius
    const P_MAX_UV    = 0.09;  // max UV displacement

    const VS = `
      attribute vec2 a_pos;
      varying   vec2 v_uv;
      void main() {
        v_uv        = a_pos * 0.5 + 0.5;
        gl_Position = vec4(a_pos, 0.0, 1.0);
      }
    `;
    const FS = `
      precision mediump float;
      uniform sampler2D u_img;
      uniform sampler2D u_disp;
      uniform vec2  u_gridSize;
      uniform float u_maxUV;
      varying vec2  v_uv;

      void main() {
        vec2 blockIdx  = floor(v_uv * u_gridSize);
        vec2 dispTexUV = (blockIdx + 0.5) / u_gridSize;
        vec4 d = texture2D(u_disp, dispTexUV);

        float uvDx = (d.r - 0.5) * 2.0 * u_maxUV;
        float uvDy = (d.g - 0.5) * 2.0 * u_maxUV;
        vec2  wuv  = clamp(v_uv + vec2(uvDx, uvDy), 0.0, 1.0);

        vec4 col = texture2D(u_img, wuv);
        float mag = length(d.rg - 0.5);
        col.a *= smoothstep(0.008, 0.022, mag);
        gl_FragColor = col;
      }
    `;

    function compile(type, src) {
      const s = gl.createShader(type);
      gl.shaderSource(s, src); gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
        console.error('[prod-distort]', gl.getShaderInfoLog(s)); return null;
      }
      return s;
    }
    const vs = compile(gl.VERTEX_SHADER, VS);
    const fs = compile(gl.FRAGMENT_SHADER, FS);
    if (!vs || !fs) { cvs.remove(); return; }

    const prog = gl.createProgram();
    gl.attachShader(prog, vs); gl.attachShader(prog, fs);
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { cvs.remove(); return; }
    gl.useProgram(prog);

    const buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 1,-1, -1,1, 1,1]), gl.STATIC_DRAW);
    const aPos = gl.getAttribLocation(prog, 'a_pos');
    gl.enableVertexAttribArray(aPos);
    gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);

    const uGridSize = gl.getUniformLocation(prog, 'u_gridSize');
    const uMaxUV    = gl.getUniformLocation(prog, 'u_maxUV');
    const uImg      = gl.getUniformLocation(prog, 'u_img');
    const uDisp     = gl.getUniformLocation(prog, 'u_disp');

    function makeTex(filter) {
      const t = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, t);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filter);
      return t;
    }
    const imgTex  = makeTex(gl.LINEAR);
    const dispTex = makeTex(gl.NEAREST);
    let imgTexOk  = null;

    // ── Block grid ────────────────────────────────────────────
    let cW = 1, cH = 1, gridW = 1, gridH = 1;
    let dispData, blockVary, dispTexData;

    function initGrid() {
      gridW = Math.ceil(cW / P_BLOCK) + 1;
      gridH = Math.ceil(cH / P_BLOCK) + 1;
      const n = gridW * gridH;
      dispData    = new Float32Array(n * 2);
      blockVary   = new Float32Array(n);
      dispTexData = new Uint8Array(n * 4);
      for (let i = 0; i < n; i++) {
        blockVary[i]       = 0.4 + Math.random() * 1.6;
        dispTexData[i*4+3] = 255;
      }
    }

    function uploadDispTex() {
      const n = gridW * gridH;
      for (let i = 0; i < n; i++) {
        dispTexData[i*4  ] = Math.max(0, Math.min(255,
          Math.round((dispData[i*2  ] / P_MAX_UV * 0.5 + 0.5) * 255)));
        dispTexData[i*4+1] = Math.max(0, Math.min(255,
          Math.round((dispData[i*2+1] / P_MAX_UV * 0.5 + 0.5) * 255)));
      }
      gl.activeTexture(gl.TEXTURE1);
      gl.bindTexture(gl.TEXTURE_2D, dispTex);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gridW, gridH, 0,
                    gl.RGBA, gl.UNSIGNED_BYTE, dispTexData);
    }

    function resize() {
      const rect = bgEl.getBoundingClientRect();
      cW = Math.round(rect.width)  || 400;
      cH = Math.round(rect.height) || 400;
      cvs.width  = cW;
      cvs.height = cH;
      gl.viewport(0, 0, cW, cH);
      initGrid();
    }
    // Call resize synchronously first so dispData/dispTexData are initialised
    // before the animation loop's first tick runs uploadDispTex().
    resize();
    new ResizeObserver(resize).observe(bgEl);

    // ── Mouse tracking ────────────────────────────────────────
    let mPxX = -9999, mPxY = -9999;
    let pMX = -9999, pMY = -9999, pvX = 0, pvY = 0;

    bgEl.addEventListener('mousemove', (e) => {
      const r = bgEl.getBoundingClientRect();
      mPxX = e.clientX - r.left;
      mPxY = e.clientY - r.top;
    });
    bgEl.addEventListener('mouseleave', () => { mPxX = -9999; });

    // ── Animation loop ────────────────────────────────────────
    let raf2;
    (function tick2() {
      raf2 = requestAnimationFrame(tick2);
      if (!cvs.isConnected) { cancelAnimationFrame(raf2); return; }

      // Velocity
      const on = mPxX > -100;
      if (on && pMX > -100) {
        pvX = pvX * 0.5 + (mPxX - pMX) * 0.5;
        pvY = pvY * 0.5 + (mPxY - pMY) * 0.5;
      } else { pvX *= 0.75; pvY *= 0.75; }
      pMX = mPxX; pMY = mPxY;

      const speed = Math.hypot(pvX, pvY);

      if (on && speed > 1.5) {
        const nx = pvX / speed, ny = pvY / speed;
        const str = Math.min(speed, 28) / 28;
        for (let gy = 0; gy < gridH; gy++) {
          for (let gx = 0; gx < gridW; gx++) {
            const bx   = gx * P_BLOCK + P_BLOCK * 0.5;
            const by   = gy * P_BLOCK + P_BLOCK * 0.5;
            const dist = Math.hypot(bx - mPxX, by - mPxY);
            if (dist > P_RADIUS_PX) continue;
            const falloff = 1 - dist / P_RADIUS_PX;
            const t       = falloff * falloff * falloff * str;
            const vary    = blockVary[gy * gridW + gx];
            const idx     = (gy * gridW + gx) * 2;
            dispData[idx    ] += nx * t * vary * P_MAX_UV;
            dispData[idx + 1] += ny * t * vary * P_MAX_UV;
            const mag = Math.hypot(dispData[idx], dispData[idx + 1]);
            if (mag > P_MAX_UV) {
              const s = P_MAX_UV / mag;
              dispData[idx] *= s; dispData[idx + 1] *= s;
            }
          }
        }
        if (Math.random() < 0.20) {
          const maxB = Math.ceil(P_RADIUS_PX / P_BLOCK);
          const sGX  = Math.round(mPxX / P_BLOCK + (Math.random() - 0.5) * maxB * 2);
          const sGY  = Math.round(mPxY / P_BLOCK + (Math.random() - 0.5) * maxB * 2);
          if (sGX >= 0 && sGX < gridW && sGY >= 0 && sGY < gridH) {
            const si = (sGY * gridW + sGX) * 2;
            dispData[si    ] = (Math.random() - 0.5) * P_MAX_UV * 2.8;
            dispData[si + 1] = (Math.random() - 0.5) * P_MAX_UV * 2.8;
          }
        }
      }

      for (let i = 0; i < dispData.length; i++) dispData[i] *= P_DECAY;

      uploadDispTex();

      // Upload source image texture once (static image, not video)
      if (imgTexOk === null && srcImg.complete && srcImg.naturalWidth > 0) {
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, imgTex);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        try {
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, srcImg);
          imgTexOk = true;
        } catch(e) { imgTexOk = false; } // CORS fallback — canvas stays transparent
      }

      gl.clear(gl.COLOR_BUFFER_BIT);
      if (imgTexOk !== true) return; // nothing to draw until image is ready

      gl.useProgram(prog);
      gl.uniform2f(uGridSize, gridW, gridH);
      gl.uniform1f(uMaxUV,    P_MAX_UV);
      gl.uniform1i(uImg,  0);
      gl.uniform1i(uDisp, 1);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    })();
  }

  /* ── Scroll cue ───────────────────────────────────────────── */

  function initScrollCue() {
    const cue = document.querySelector('.hero__scroll-cue');
    if (!cue) return;

    cue.addEventListener('click', () => {
      const target = document.querySelector('.product-grid') ||
                     document.querySelector('main > *:nth-child(2)');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.scrollBy({ top: window.innerHeight, behavior: 'smooth' });
      }
    });
  }

  /* ── Header scroll behaviour ──────────────────────────────── */

  function initHeader() {
    const header = $('.site-header');
    if (!header) return;

    function updateHeader() {
      if (window.scrollY > 20) {
        header.classList.add('is-solid');
      } else {
        header.classList.remove('is-solid');
      }
    }

    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  /* ── Navigation drawer ────────────────────────────────────── */

  function initNav() {
    const nav       = $('#site-nav');
    const openBtn   = $('#nav-open');
    const closeBtn  = $('#nav-close');
    const overlay   = $('#nav-overlay');

    if (!nav || !openBtn) return;

    function openNav() {
      nav.setAttribute('aria-hidden', 'false');
      document.body.classList.add('page-overlay-active');
      closeBtn && closeBtn.focus();
    }

    function closeNav() {
      nav.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('page-overlay-active');
      openBtn && openBtn.focus();
    }

    openBtn.addEventListener('click', openNav);
    closeBtn && closeBtn.addEventListener('click', closeNav);
    overlay  && overlay.addEventListener('click', closeNav);

    nav.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeNav();
    });
  }

  /* ── Cart drawer ──────────────────────────────────────────── */

  function initCart() {
    const drawer  = $('#cart-drawer');
    const openBtn = $('#cart-open');
    const closeBtn = $('#cart-close');
    const overlay  = $('#cart-overlay');

    if (!drawer) return;

    function openCart() {
      refreshCart();
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('page-overlay-active');
    }

    function closeCart() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('page-overlay-active');
    }

    openBtn  && openBtn.addEventListener('click', openCart);
    closeBtn && closeBtn.addEventListener('click', closeCart);
    overlay  && overlay.addEventListener('click', closeCart);

    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeCart();
    });

    // Expose for use by add-to-bag
    window.COT = window.COT || {};
    window.COT.openCart  = openCart;
    window.COT.closeCart = closeCart;
  }

  async function refreshCart() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
    } catch (e) {
      console.error('Cart fetch failed', e);
    }
  }

  function renderCart(cart) {
    const body   = $('#cart-body');
    const footer = $('#cart-footer');
    const total  = $('#cart-total');

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">YOUR BAG IS EMPTY</p>';
      footer && (footer.style.display = 'none');
    } else {
      body.innerHTML = cart.items.map(item => `
        <div class="cart-item">
          <img class="cart-item__img"
               src="${item.image ? item.image.replace('_1024x1024', '_200x200') : ''}"
               alt="${item.title}" loading="lazy">
          <div class="cart-item__details">
            <p class="cart-item__title">${item.product_title}</p>
            ${item.variant_title ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
            <p class="cart-item__price">${formatMoney(item.final_line_price)}</p>
            <button class="cart-item__remove" data-key="${item.key}">REMOVE</button>
          </div>
        </div>
      `).join('');

      footer && (footer.style.display = 'flex');
      total  && (total.textContent = formatMoney(cart.total_price));

      // Remove item handlers
      $$('.cart-item__remove').forEach(btn => {
        btn.addEventListener('click', async () => {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
          });
          refreshCart();
          updateCartCount();
        });
      });
    }

    updateCartCount();
  }

  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const countEl = $('.cart-count');
      if (countEl) countEl.textContent = cart.item_count || '';
    } catch (e) {}
  }

  /* ── Add to bag ───────────────────────────────────────────── */

  function initAddToBag() {
    const form = $('#product-form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('.btn-add-to-bag');
      const data = new FormData(form);

      btn && btn.classList.add('is-loading');
      if (btn) btn.textContent = 'ADDING…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: data.get('id'),
            quantity: 1
          })
        });

        if (!res.ok) throw new Error('Add failed');

        await updateCartCount();
        window.COT && window.COT.openCart && window.COT.openCart();

      } catch (err) {
        console.error(err);
        if (btn) btn.textContent = 'UNAVAILABLE';
      } finally {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.textContent = 'ADD TO BAG';
        }
      }
    });
  }

  /* ── Variant selection ────────────────────────────────────── */

  function initVariants() {
    const btns = $$('.variant-btn');
    if (!btns.length) return;

    const hiddenInput = $('#variant-id');

    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        btns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        if (hiddenInput) hiddenInput.value = btn.dataset.variantId;

        // Update price display
        const price = btn.dataset.price;
        const priceEl = $('.product-detail__price');
        if (priceEl && price) priceEl.textContent = formatMoney(parseInt(price, 10));

        // Disable add-to-bag if OOS
        const addBtn = $('.btn-add-to-bag');
        if (addBtn) {
          if (btn.dataset.available === 'false') {
            addBtn.disabled = true;
            addBtn.textContent = 'SOLD OUT';
          } else {
            addBtn.disabled = false;
            addBtn.textContent = 'ADD TO BAG';
          }
        }
      });
    });
  }

  /* ── Description accordion ────────────────────────────────── */

  function initAccordion() {
    const toggle = $('.product-detail__description-toggle');
    const body   = $('.product-detail__description-body');
    if (!toggle || !body) return;

    toggle.addEventListener('click', () => {
      const isOpen = body.classList.toggle('is-open');
      toggle.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ── Cart page ────────────────────────────────────────────── */

  function initCartPage() {
    const page = document.querySelector('.cart-page');
    if (!page) return;

    async function renderCartPage() {
      try {
        const res  = await fetch('/cart.js');
        const cart = await res.json();
        const list    = page.querySelector('.cart-page__items');
        const empty   = page.querySelector('.cart-page__empty');
        const summary = page.querySelector('.cart-page__summary');

        if (!list) return;

        if (cart.item_count === 0) {
          list.innerHTML = '';
          if (empty)   empty.style.display   = 'block';
          if (summary) summary.style.display = 'none';
          return;
        }

        if (empty)   empty.style.display   = 'none';
        if (summary) summary.style.display = 'flex';

        list.innerHTML = cart.items.map(item => `
          <div class="cart-page__item">
            ${item.image
              ? `<img class="cart-page__img" src="${item.image.replace('_1024x1024','_300x300')}" alt="${item.title}" loading="lazy">`
              : '<div class="cart-page__img-placeholder"></div>'
            }
            <div>
              <p class="cart-page__item-title">${item.product_title}</p>
              ${item.variant_title ? `<p class="cart-page__item-variant">${item.variant_title}</p>` : ''}
              <div class="cart-page__qty">
                <button class="cart-page__qty-btn" data-key="${item.key}" data-qty="${item.quantity}" data-action="dec" aria-label="Decrease">&#8722;</button>
                <span class="cart-page__qty-val">${item.quantity}</span>
                <button class="cart-page__qty-btn" data-key="${item.key}" data-qty="${item.quantity}" data-action="inc" aria-label="Increase">+</button>
              </div>
              <button class="cart-page__item-remove" data-key="${item.key}">REMOVE</button>
            </div>
            <p class="cart-page__item-price">${formatMoney(item.final_line_price)}</p>
          </div>
        `).join('');

        const subEl = page.querySelector('#cart-page-subtotal');
        if (subEl) subEl.textContent = formatMoney(cart.total_price);

        page.querySelectorAll('.cart-page__qty-btn').forEach(btn => {
          btn.addEventListener('click', async () => {
            const qty    = parseInt(btn.dataset.qty, 10);
            const newQty = btn.dataset.action === 'inc' ? qty + 1 : qty - 1;
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: btn.dataset.key, quantity: Math.max(0, newQty) })
            });
            renderCartPage();
            updateCartCount();
          });
        });

        page.querySelectorAll('.cart-page__item-remove').forEach(btn => {
          btn.addEventListener('click', async () => {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
            });
            renderCartPage();
            updateCartCount();
          });
        });

      } catch (e) {
        console.error('Cart page error', e);
      }
    }

    renderCartPage();
  }

  /* ── Init ─────────────────────────────────────────────────── */

  function init() {
    initLanding();
    initDistortEffect();
    try { initProductImageDistort(); } catch(e) { console.error('[prod-distort]', e); }
    initScrollCue();
    initHeader();
    initNav();
    initCart();
    initAddToBag();
    initVariants();
    initAccordion();
    initCartPage();
    updateCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
